import { Component, EventEmitter, Input, Output } from '@angular/core';

import { StateType, States } from '../permissions-legend/permissions-legend.component';
import { ActionPermissionList } from '../permissions-list/permissions-list.component';
import { AclNode, AclTreeItem, TreeViewGenericPermissionsService } from './treeview-generic-permissions.service';

export type GenericPermissionAction = {
    uid: string;
    action: StateType;
};

export interface ForceButtons {
    type: StateType;
    header: string;
}

/** This component displays the permissions list used in permissions editor. An event will be emitted when an action is clicked. */
@Component({
    selector: 'cw-treeview-generic-permissions',
    templateUrl: './treeview-generic-permissions.component.html',
    styleUrls: ['./treeview-generic-permissions.component.scss'],
    standalone: false,
})
export class TreeviewGenericPermissionsComponent {
    /** List of item to be displayed in the component */
    @Input() list: AclTreeItem[] = [];

    /** If this property is true, shows the header */
    @Input() hasHeader = false;

    /** If this property is false, hides the tree items */
    @Input() isExpanded = true;

    /** If this input is true the checks will be readonly */
    @Input() areChecksReadonly = false;

    /** If this property is true disables the checkbox  */
    @Input() disabledCheckbox = false;

    /** When this input is true a loader will be displayed */
    @Input() isLoading = false;

    /** Buttons to force permissions */
    @Input() extraButtons: ForceButtons[] = [];

    /** It will be emitted when clicking in an icon action */
    @Output() actionClick = new EventEmitter<ActionPermissionList>();

    /** It will be emitted when selecting an item */
    @Output() checkboxChanged = new EventEmitter<any>();

    @Output() extraButtonClicked = new EventEmitter<GenericPermissionAction>();

    constructor(private treeviewGenericPermissionsService: TreeViewGenericPermissionsService) {}

    /**
     * Emits the node selected by the checkbox
     * @param node
     */
    onCheckboxChange(node: any): void {
        this.checkboxChanged.emit(node);
    }

    /**
     * Emits the node selected by the extra button
     * @param node
     */
    onExtraButtonClick(node: any, type: StateType): void {
        this.extraButtonClicked.emit({ uid: node.uid, action: type } as GenericPermissionAction);
    }

    getIconForceButton(type: StateType): string {
        return type === States.allow ? 'check-fill' : 'stop-fill';
    }

    isIconDisabled(node: AclNode, button: ForceButtons): boolean {
        const isActive = (node as any)[button.type];
        return !isActive;
    }
}
